import React from "react";
import { Menu } from "antd";
import translator from "@/translator";
import { File, User, Bell, Next, Calendar } from "@/note_office/icons/menu";

const t = translator("note_office.views.bookings_menu.menuItems.");

const BookingsMenu = ({ bookingsMenuData }) => {
  const bookingServices = [
    {
      key: "description",
      icon: <User />,
      label: (
        <div className="profile__menu-item">
          <a href={bookingsMenuData.edit_customer_profile_url} className="profile__menu-link">
            {t("description")}
          </a>
          <span className="profile__menu-arrow">
            <Next />
          </span>
        </div>
      ),
    },
    {
      key: "services",
      icon: <File />,
      label: (
        <div className="profile__menu-item">
          <a href={bookingsMenuData.services_url} className="profile__menu-link">
            {t("services")}
          </a>
          <span className="profile__menu-arrow">
            <Next />
          </span>
        </div>
      ),
    },
    {
      key: "schedule",
      icon: <Calendar />,
      label: (
        <div className="profile__menu-item">
          <a href="" className="profile__menu-link">
            {t("schedule")}
          </a>
          <span className="profile__menu-arrow">
            <Next />
          </span>
        </div>
      ),
    },
    {
      key: "reminders",
      icon: <Bell />,
      label: (
        <div className="profile__menu-item">
          <a href={bookingsMenuData.notifications_url} className="profile__menu-link">
            {t("reminders")}
          </a>
          <span className="profile__menu-arrow">
            <Next />
          </span>
        </div>
      ),
    },
  ];

  return (
    <Menu mode="vertical" items={bookingServices} className="profile__menu" selectedKeys={[]} />
  );
};

export default BookingsMenu;
